import React, { useEffect, useState, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
import { ThankYouPage } from './pages/ThankYouPage';
export type PageType = 'sales' | 'thankyou';
export function App() {
  const [currentPage, setCurrentPage] = useState<PageType>('sales');
  // SEO meta tags (lightweight, runs once)
  useEffect(() => {
    document.documentElement.lang = 'es';
    document.title = 'El Blindaje Operativo AFIP — Pack 5 Tomos + Bonos | Fegion';
    const tags: Array<[string, string, string]> = [['name', 'description', 'Protocolo de Auditoría Preventiva Anti-SIAp para Contadores Públicos Argentinos. 5 Tomos + 3 Bonos exclusivos. Blindá tu estudio contable contra requerimientos de AFIP con un sistema probado.'], ['property', 'og:title', 'El Blindaje Operativo AFIP — Pack 5 Tomos + Bonos'], ['property', 'og:description', 'Protocolo de Auditoría Preventiva para Contadores Públicos Argentinos. Blindá tu estudio contra AFIP.'], ['property', 'og:type', 'website'], ['property', 'og:image', 'https://cdn.magicpatterns.com/uploads/fwAMEfmABbyUQnKfQPjd2j/portadita.._(1).png'], ['property', 'og:locale', 'es_AR']];
    tags.forEach(([attr, key, content]) => {
      if (!document.querySelector(`meta[${attr}="${key}"]`)) {
        const m = document.createElement('meta');
        m.setAttribute(attr, key);
        m.content = content;
        document.head.appendChild(m);
      }
    });
    if (!document.querySelector('link[rel="canonical"]')) {
      const c = document.createElement('link');
      c.rel = 'canonical';
      c.href = window.location.origin + window.location.pathname;
      document.head.appendChild(c);
    }
  }, []);
  // Meta Pixel - deferred until browser is idle (minimizes TBT and main thread work)
  useEffect(() => {
    const loadPixel = () => {
      if (document.getElementById('fb-pixel-init')) return;
      const s = document.createElement('script');
      s.id = 'fb-pixel-init';
      s.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','904978025482552');fbq('track','PageView');`;
      document.head.appendChild(s);
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=904978025482552&ev=PageView&noscript=1';
      document.body.appendChild(img);
    };
    // Wait for page to fully load, then wait for idle time
    if (document.readyState === 'complete') {
      if ('requestIdleCallback' in window) {
        ;
        (window as any).requestIdleCallback(loadPixel, {
          timeout: 5000
        });
      } else {
        setTimeout(loadPixel, 4000);
      }
    } else {
      window.addEventListener('load', () => {
        if ('requestIdleCallback' in window) {
          ;
          (window as any).requestIdleCallback(loadPixel, {
            timeout: 5000
          });
        } else {
          setTimeout(loadPixel, 4000);
        }
      }, {
        once: true
      });
    }
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);
  const navigate = (page: PageType) => setCurrentPage(page);
  return <div className="min-h-screen bg-gradient-to-b from-navy-900 to-navy-800 text-offwhite font-sans" data-id="element-0">
      {currentPage === 'sales' && <SalesPage navigate={navigate} data-id="element-1" />}
      {currentPage === 'thankyou' && <ThankYouPage navigate={navigate} data-id="element-2" />}
    </div>;
}